module.exports = __webpack_public_path__ + "img/wp-new-habit-card2.d921e9f8.jpg";